/**
 * Setvoordeel (2026-10-24) — only for visitors of /pages/set-sale.
 * The set-sale page marks the cart with attribute _tl_setactie=1.
 * For marked carts this keeps the right code on the cart:
 *   2 paid products → SETVOORDEEL10 · 3+ → SETVOORDEEL20 · else none (set + extra counts as its parts).
 * Codes are scoped to eligible products in Shopify (book / insurance never count).
 * A code the customer typed themselves is never touched.
 */
(function () {
  if (window.__tlSetVoordeel) return;
  window.__tlSetVoordeel = true;

  var PREFIX = "SETVOORDEEL";
  var EXCLUDE = ["order-protection", "titanore-titanium-cookbook", "the-titanium-table"];
  // A set with an extra counts as its parts (2026-10-31): set + kookpan = 2, complete keuken = 4.
  var UNITS = {"set-3-pannen-kookpan": 2, "set-3-pannen-wok": 2, "set-3-pannen-snijplank": 2, "chefs-pan-set-3-pans-titanium-utensils": 2, "twee-handgrepen-set-3-titanium-utensils": 2, "sauteerpan-set-3-titanium-utensils": 2, "complete-keuken-pannenset": 4};
  var busy = false;
  var again = false;
  var timer = null;

  function root() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    } catch (e) {}
    return "/";
  }

  function onSalePage() {
    return /\/pages\/set-sale\/?$/.test(location.pathname || "");
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return fetch(root() + "cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (r) {
      return r.json();
    });
  }

  function eligibleCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      var h = String(item.handle || "").toLowerCase();
      if (EXCLUDE.indexOf(h) !== -1) return;
      if (!(item.original_price > 0)) return;
      n += item.quantity * (UNITS[h] || 1);
    });
    return n;
  }

  function refresh() {
    if (typeof window.tlRefreshCartDrawerSections === "function") window.tlRefreshCartDrawerSections();
    document.dispatchEvent(new CustomEvent("tl:setvoordeel", { detail: {} }));
  }

  function sync() {
    if (busy) {
      again = true;
      return Promise.resolve();
    }
    busy = true;
    return getCart()
      .then(function (cart) {
        var marked = cart.attributes && cart.attributes._tl_setactie === "1";
        if (!marked && onSalePage()) {
          marked = true;
          return post("cart/update.js", { attributes: { _tl_setactie: "1" } }).then(function () {
            return getCart();
          });
        }
        return marked ? cart : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var codes = (cart.discount_codes || []).map(function (d) {
          return String(d.code || "").toUpperCase();
        });
        var own = codes.filter(function (c) { return c.indexOf(PREFIX) === 0; });
        var other = codes.filter(function (c) { return c.indexOf(PREFIX) !== 0; });
        if (other.length) return; // customer's own code wins
        var n = eligibleCount(cart);
        var want = n >= 3 ? PREFIX + "20" : n === 2 ? PREFIX + "10" : "";
        if ((own[0] || "") === want && own.length <= 1) return;
        return post("cart/update.js", { discount: want }).then(refresh);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  window.tlSetVoordeelSync = sync;

  ["cart:updated", "cart:refresh", "cart-drawer:update"].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  // Catch every cart mutation, whichever script made it.
  try {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !/discount/.test(String(arguments[1] && arguments[1].body || ""))) {
          p.then(schedule, function () {});
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
})();
